import { render, staticRenderFns } from "./RegisterBuyPackageComponent.vue?vue&type=template&id=c7606cfc&scoped=true"
import script from "./RegisterBuyPackageComponent.vue?vue&type=script&lang=js"
export * from "./RegisterBuyPackageComponent.vue?vue&type=script&lang=js"
import style0 from "./RegisterBuyPackageComponent.vue?vue&type=style&index=0&id=c7606cfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7606cfc",
  null
  
)

export default component.exports